import {
  SALE_PRODUCTS_SET, NEW_PRODUCTS_SET, POPULAR_PRODUCTS_SET
} from "../actions/sale_new_popular_actions";

const initialState = {
  saleProducts: [],
  newProducts: [],
  popularProducts: [],
};

export const saleNewPopularReducer = (state = initialState, action) => {
  switch (action.type) {
    case SALE_PRODUCTS_SET: {
      return {
        ...state,
        saleProducts: action.payload
      }
    }
    case NEW_PRODUCTS_SET: {
      return {
        ...state,
        newProducts: action.payload
      }
    }
    case POPULAR_PRODUCTS_SET: {
      return {
        ...state,
        popularProducts: action.payload
      }
    }
    default: return state;
  }
}
